import { useEffect, useRef } from 'react';
import { useUserStore } from '@/stores/user/userStore';
import useNewUpdatesModalStore from '@/stores/newUpdatesModal/newUpdatesModalStore';

const STORAGE_KEY = 'newUpdatesModalSeen';

/**
 * Hook to manage the New Updates Modal
 * This hook shows the modal to all users after login with a 10-second delay
 * The modal state is saved in localStorage and cleared on logout
 */
const useNewUpdatesModal = () => {
  const user = useUserStore((state) => state.user);
  const auth = useUserStore((state) => state.auth);
  const { showModal, reset } = useNewUpdatesModalStore();
  const timerRef = useRef(null);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (user && auth?.access_token && user?.seen_black_friday_modal !== undefined && !hasInitialized.current && !timerRef.current) {
      hasInitialized.current = true;

      const hasSeenModal = localStorage.getItem(STORAGE_KEY) === 'true';
      const hasSeenBlackFridayModal = user?.seen_black_friday_modal === true;

      if (!hasSeenModal && hasSeenBlackFridayModal && false) {
        // Show modal with a 10-second delay
        timerRef.current = setTimeout(() => {
          showModal();
          timerRef.current = null;
        }, 10000);
      }
    }

    // Reset when user logs out
    if (!user || !auth?.access_token) {
      hasInitialized.current = false;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      reset();
    }

    // Cleanup function
    return () => {
      // Don't clear the timer here unless component is unmounting
      // This prevents the timer from being cleared on re-renders
    };
  }, [user, auth?.access_token, showModal, reset, user?.seen_black_friday_modal]);

  // Return the modal store for components that need direct access
  return useNewUpdatesModalStore();
};

export default useNewUpdatesModal;

